var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path0, _g7, _path1, _g8, _path10, _g9, _path11, _g0, _path12, _g1, _path13, _g10, _path14, _g11, _path15, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1151,
    height: 667,
    viewBox: "0 0 1151 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.22 371.693C710.22 371.693 668.849 323.047 799.494 266.773C930.138 210.495 1041.19 190.464 970.426 58.8373C970.426 58.8373 1047.72 98.8936 1019.41 180.925C1019.41 180.925 1075.43 126.858 1025.65 38C1025.65 38 1111.22 91.2691 1046.27 196.189C1046.27 196.189 1118.49 184.739 1102.16 76.9583C1102.16 76.9583 1163.13 179.017 1041.19 235.295C1041.19 235.295 1106.51 222.895 1137 178.064C1137 178.064 1118.49 247.691 1019.41 262.955C1019.41 262.955 1088.01 273.107 1137 227.492C1137 227.492 1127.97 272.883 1020.5 293.48C1020.5 293.48 1091.27 290.616 1123.93 277.266C1123.93 277.266 1089.09 320.183 998.728 322.089C998.728 322.089 1045.55 331.94 1105.42 316.529C1105.42 316.529 1046.63 359.29 963.887 357.383C963.887 357.383 1012.61 367.986 1063.78 360.357C1063.78 360.357 951.706 423.731 861.544 338.49C861.544 338.49 909.65 350.104 953.237 336.257C953.237 336.257 905.587 332.917 869.692 306.799C869.692 306.799 920.1 314.941 961.389 293.86C961.389 293.86 913.24 299.366 869.692 283.147C869.692 283.147 933.872 274.714 957.821 236.734C957.821 236.734 916.562 278.683 833.242 280.127C833.242 280.127 903.076 301.002 920.499 301.002C920.499 301.002 864.814 305.875 845.219 298.244C845.219 298.244 875.806 330.9 924.71 336.705C924.71 336.705 858.513 338.205 842.183 328.669C842.183 328.669 906.372 411.681 1029.14 383.564C1029.14 383.564 962.803 437.507 880.06 394.581C880.06 394.581 904.889 420.75 951.707 425.516C951.707 425.516 900.258 442.923 844.135 412.707C844.135 412.707 872.437 440.366 889.86 448C889.86 448 763.568 444.185 710.22 371.693Z",
    fill: "url(#paint0_linear_1_405)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.78 371.693C440.78 371.693 482.151 323.047 351.506 266.773C220.862 210.495 109.808 190.464 180.574 58.8373C180.574 58.8373 103.278 98.8936 131.588 180.925C131.588 180.925 75.5693 126.858 125.349 38C125.349 38 39.7786 91.2691 104.73 196.189C104.73 196.189 32.5111 184.739 48.8411 76.9583C48.8411 76.9583 -12.1255 179.017 109.808 235.295C109.808 235.295 44.492 222.895 14 178.064C14 178.064 32.5111 247.691 131.588 262.955C131.588 262.955 62.9945 273.107 14 227.492C14 227.492 23.0322 272.883 130.5 293.48C130.5 293.48 59.7293 290.616 27.0692 277.266C27.0692 277.266 61.906 320.183 152.272 322.089C152.272 322.089 105.454 331.94 45.5803 316.529C45.5803 316.529 104.366 359.29 187.113 357.383C187.113 357.383 138.392 367.986 87.2206 360.357C87.2206 360.357 199.294 423.731 289.456 338.49C289.456 338.49 241.35 350.104 197.763 336.257C197.763 336.257 245.413 332.917 281.308 306.799C281.308 306.799 230.9 314.941 189.611 293.86C189.611 293.86 237.76 299.366 281.308 283.147C281.308 283.147 217.128 274.714 193.179 236.734C193.179 236.734 234.438 278.683 317.758 280.127C317.758 280.127 247.924 301.002 230.501 301.002C230.501 301.002 286.186 305.875 305.781 298.244C305.781 298.244 275.194 330.9 226.29 336.705C226.29 336.705 292.487 338.205 308.817 328.669C308.817 328.669 244.628 411.681 121.858 383.564C121.858 383.564 188.197 437.507 270.94 394.581C270.94 394.581 246.111 420.75 199.293 425.516C199.293 425.516 250.742 442.923 306.865 412.707C306.865 412.707 278.563 440.366 261.14 448C261.14 448 387.432 444.185 440.78 371.693Z",
    fill: "url(#paint1_linear_1_405)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M671.385 618.947H481.703C456.983 618.947 436.944 598.908 436.944 574.188V276.727V232.992V221.705V177.971V159.099V136.649V90.8974C436.944 66.1774 456.983 46.1387 481.703 46.1387H671.385C696.105 46.1387 716.144 66.1774 716.144 90.8974V574.188C716.144 598.908 696.105 618.947 671.385 618.947ZM482.053 47.472C457.876 47.472 438.277 67.0707 438.277 91.248V573.837C438.277 598.015 457.876 617.614 482.053 617.614H671.035C695.212 617.614 714.811 598.015 714.811 573.837V91.248C714.811 67.0707 695.212 47.472 671.035 47.472H482.053ZM670.684 616.28H482.404C458.769 616.28 439.611 597.121 439.611 573.486V91.5988C439.611 67.9641 458.769 48.8054 482.404 48.8054H670.684C694.317 48.8054 713.477 67.9641 713.477 91.5988V573.486C713.477 597.121 694.317 616.28 670.684 616.28ZM482.827 50.5107C460.097 50.5107 441.672 68.9361 441.672 91.6654V573.42C441.672 596.149 460.097 614.575 482.827 614.575H670.261C692.991 614.575 711.416 596.149 711.416 573.42V91.6654C711.416 68.9361 692.991 50.5107 670.261 50.5107H482.827Z",
    fill: "#5E465D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461 604L696 62.9012L685.5 53L475 56.4654L450 69.832L446 584.198L461 604Z",
    fill: "url(#paint2_linear_1_405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M691 62L456 599.171L466.5 609L677 605.56L702 592.29L706 81.6586L691 62Z",
    fill: "url(#paint3_linear_1_405)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M671.035 617.614H482.053C457.876 617.614 438.277 598.015 438.277 573.837V91.248C438.277 67.0706 457.876 47.472 482.053 47.472H671.035C695.212 47.472 714.811 67.0706 714.811 91.248V573.837C714.811 598.015 695.212 617.614 671.035 617.614ZM482.404 48.8053C458.769 48.8053 439.611 67.964 439.611 91.5987V573.486C439.611 597.121 458.769 616.28 482.404 616.28H670.684C694.317 616.28 713.477 597.121 713.477 573.486V91.5987C713.477 67.964 694.317 48.8053 670.684 48.8053H482.404Z",
    fill: "#A597A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M670.261 614.575H482.827C460.097 614.575 441.672 596.149 441.672 573.42V91.6654C441.672 68.9361 460.097 50.5107 482.827 50.5107H670.261C692.991 50.5107 711.416 68.9361 711.416 91.6654V573.42C711.416 596.149 692.991 614.575 670.261 614.575ZM482.617 59.64C464.904 59.64 450.545 74 450.545 91.7134V573.372C450.545 591.085 464.904 605.445 482.619 605.445H670.469C688.184 605.445 702.543 591.085 702.543 573.372V91.7134C702.543 74 688.184 59.64 670.469 59.64H648.671H504.159C496.715 59.64 489.651 59.64 482.617 59.64Z",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 716,
    y: 192,
    width: 2,
    height: 70
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M716.144 261.529H717.778V192.491H716.144V261.529Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.144 261.529H717.778V192.491H716.144V261.529Z",
    fill: "url(#paint4_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 717,
    y: 192,
    width: 2,
    height: 70
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M717.779 261.532V192.509L718.596 193.405C718.183 200.755 718.211 253.303 718.596 260.636L717.779 261.532Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.779 261.532V192.509L718.596 193.405C718.183 200.755 718.211 253.303 718.596 260.636L717.779 261.532Z",
    fill: "url(#paint5_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 177,
    width: 1,
    height: 45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 221.692H435.011V177.959H435.944V221.692Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 221.692H435.011V177.959H435.944V221.692Z",
    fill: "url(#paint6_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 434,
    y: 177,
    width: 2,
    height: 45
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M435.011 221.695L434.544 221.127C434.764 216.481 434.78 183.193 434.544 178.539L435.011 177.971V221.692V221.695Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.011 221.695L434.544 221.127C434.764 216.481 434.78 183.193 434.544 178.539L435.011 177.971V221.692V221.695Z",
    fill: "url(#paint7_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 177,
    width: 2,
    height: 45
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 221.705H436.944V177.971H435.944V221.705Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 221.705H436.944V177.971H435.944V221.705Z",
    fill: "url(#paint8_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 232,
    width: 1,
    height: 45
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 276.713H435.011V232.98H435.944V276.713Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 276.713H435.011V232.98H435.944V276.713Z",
    fill: "url(#paint9_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 434,
    y: 232,
    width: 2,
    height: 45
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M435.011 276.716L434.544 276.148C434.764 271.503 434.78 238.215 434.544 233.56L435.011 232.992V276.713V276.716Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.011 276.716L434.544 276.148C434.764 271.503 434.78 238.215 434.544 233.56L435.011 232.992V276.713V276.716Z",
    fill: "url(#paint10_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 232,
    width: 2,
    height: 45
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 276.727H436.944V232.992H435.944V276.727Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 276.727H436.944V232.992H435.944V276.727Z",
    fill: "url(#paint11_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 136,
    width: 1,
    height: 24
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 159.085H435.011V136.639H435.944V159.085Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 159.085H435.011V136.639H435.944V159.085Z",
    fill: "url(#paint12_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 434,
    y: 136,
    width: 2,
    height: 24
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.011 159.088L434.544 158.551C434.764 154.157 434.78 141.589 434.544 137.185L435.011 136.649V159.085V159.088Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.011 159.088L434.544 158.551C434.764 154.157 434.78 141.589 434.544 137.185L435.011 136.649V159.085V159.088Z",
    fill: "url(#paint13_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 435,
    y: 136,
    width: 2,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M435.944 159.099H436.944V136.65H435.944V159.099Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.944 159.099H436.944V136.65H435.944V159.099Z",
    fill: "url(#paint14_linear_1_405)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M597.633 86.2107H553.033C548.015 86.2107 543.947 82.1427 543.947 77.124C543.947 72.1054 548.015 68.0373 553.033 68.0373H597.633C602.652 68.0373 606.72 72.1054 606.72 77.124C606.72 82.1427 602.652 86.2107 597.633 86.2107ZM595.121 73.1574C592.931 73.1574 591.155 74.9334 591.155 77.124C591.155 79.316 592.931 81.0907 595.121 81.0907C597.312 81.0907 599.088 79.316 599.088 77.124C599.088 74.9334 597.312 73.1574 595.121 73.1574Z",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 591,
    y: 73,
    width: 9,
    height: 9
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M595.121 81.0907C592.931 81.0907 591.155 79.316 591.155 77.124C591.155 74.9334 592.931 73.1574 595.121 73.1574C597.312 73.1574 599.088 74.9334 599.088 77.124C599.088 79.316 597.312 81.0907 595.121 81.0907ZM595.107 73.4214C594.737 73.4214 594.367 73.476 594.008 73.588C593.431 73.7707 592.916 74.088 592.5 74.5053C592.259 74.7453 592.052 75.02 591.884 75.32C591.38 76.224 591.297 77.2893 591.596 78.2427C591.771 78.8 592.076 79.3187 592.501 79.7453C592.917 80.16 593.432 80.4787 594.009 80.66C594.368 80.7734 594.739 80.828 595.108 80.828C595.54 80.828 595.969 80.752 596.375 80.6066C596.883 80.4253 597.353 80.1347 597.743 79.7453C598.169 79.3187 598.472 78.8 598.647 78.2427C598.947 77.2893 598.864 76.224 598.36 75.32C598.193 75.02 597.985 74.7453 597.744 74.5053C597.355 74.1147 596.884 73.824 596.376 73.6413C595.969 73.496 595.539 73.4214 595.107 73.4214Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.121 81.0907C592.931 81.0907 591.155 79.316 591.155 77.124C591.155 74.9334 592.931 73.1574 595.121 73.1574C597.312 73.1574 599.088 74.9334 599.088 77.124C599.088 79.316 597.312 81.0907 595.121 81.0907ZM595.107 73.4214C594.737 73.4214 594.367 73.476 594.008 73.588C593.431 73.7707 592.916 74.088 592.5 74.5053C592.259 74.7453 592.052 75.02 591.884 75.32C591.38 76.224 591.297 77.2893 591.596 78.2427C591.771 78.8 592.076 79.3187 592.501 79.7453C592.917 80.16 593.432 80.4787 594.009 80.66C594.368 80.7734 594.739 80.828 595.108 80.828C595.54 80.828 595.969 80.752 596.375 80.6066C596.883 80.4253 597.353 80.1347 597.743 79.7453C598.169 79.3187 598.472 78.8 598.647 78.2427C598.947 77.2893 598.864 76.224 598.36 75.32C598.193 75.02 597.985 74.7453 597.744 74.5053C597.355 74.1147 596.884 73.824 596.376 73.6413C595.969 73.496 595.539 73.4214 595.107 73.4214Z",
    fill: "url(#paint15_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 591,
    y: 73,
    width: 8,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M595.108 80.828C594.739 80.828 594.368 80.7734 594.009 80.66C593.432 80.4787 592.917 80.16 592.501 79.7453C592.076 79.3187 591.771 78.8 591.596 78.2427C591.297 77.2893 591.38 76.224 591.884 75.32C592.052 75.02 592.259 74.7453 592.5 74.5053C592.916 74.088 593.431 73.7707 594.008 73.588C594.367 73.476 594.737 73.4214 595.107 73.4214C595.539 73.4214 595.969 73.496 596.376 73.6413C596.884 73.824 597.355 74.1147 597.744 74.5053C597.985 74.7453 598.193 75.02 598.36 75.32C598.864 76.224 598.947 77.2893 598.647 78.2427C598.472 78.8 598.169 79.3187 597.743 79.7453C597.353 80.1347 596.883 80.4253 596.375 80.6066C595.969 80.752 595.54 80.828 595.108 80.828ZM595.121 74.8574C593.871 74.8574 592.856 75.872 592.856 77.124C592.856 78.376 593.871 79.3907 595.121 79.3907C596.373 79.3907 597.389 78.376 597.389 77.124C597.389 75.872 596.373 74.8574 595.121 74.8574Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.12,
    y: 72.2534,
    width: 9.76003,
    height: 9.76003,
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 74,
    width: 6,
    height: 6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M595.121 79.3907C593.871 79.3907 592.856 78.3761 592.856 77.1241C592.856 75.8721 593.871 74.8574 595.121 74.8574C596.373 74.8574 597.389 75.8721 597.389 77.1241C597.389 78.3761 596.373 79.3907 595.121 79.3907ZM593.137 77.1267C593.137 78.2214 594.02 79.1094 595.12 79.1094C595.471 79.1094 595.801 79.0174 596.088 78.8574C596.128 78.8641 596.168 78.8694 596.211 78.8694C596.601 78.8694 596.919 78.5507 596.919 78.1601C596.919 78.1054 596.912 78.0521 596.901 78.0027C597.031 77.7387 597.104 77.4401 597.104 77.1267C597.104 76.0267 596.216 75.1414 595.12 75.1414C594.02 75.1414 593.137 76.0267 593.137 77.1267Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.121 79.3907C593.871 79.3907 592.856 78.3761 592.856 77.1241C592.856 75.8721 593.871 74.8574 595.121 74.8574C596.373 74.8574 597.389 75.8721 597.389 77.1241C597.389 78.3761 596.373 79.3907 595.121 79.3907ZM593.137 77.1267C593.137 78.2214 594.02 79.1094 595.12 79.1094C595.471 79.1094 595.801 79.0174 596.088 78.8574C596.128 78.8641 596.168 78.8694 596.211 78.8694C596.601 78.8694 596.919 78.5507 596.919 78.1601C596.919 78.1054 596.912 78.0521 596.901 78.0027C597.031 77.7387 597.104 77.4401 597.104 77.1267C597.104 76.0267 596.216 75.1414 595.12 75.1414C594.02 75.1414 593.137 76.0267 593.137 77.1267Z",
    fill: "url(#paint16_linear_1_405)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 593,
    y: 75,
    width: 5,
    height: 5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M595.12 79.1093C594.02 79.1093 593.137 78.2214 593.137 77.1267C593.137 76.0267 594.02 75.1413 595.12 75.1413C596.216 75.1413 597.104 76.0267 597.104 77.1267C597.104 77.44 597.031 77.7387 596.901 78.0027C596.829 77.6867 596.547 77.452 596.211 77.452C595.819 77.452 595.503 77.7694 595.503 78.16C595.503 78.5094 595.755 78.8 596.088 78.8574C595.801 79.0174 595.471 79.1093 595.12 79.1093Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.987,
    y: 74.12,
    width: 5.89336,
    height: 5.89336,
    fill: "url(#pattern1)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 596,
    y: 78,
    width: 1,
    height: 1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M596.211 78.8694C596.168 78.8694 596.128 78.8641 596.088 78.8574C596.439 78.6614 596.723 78.3627 596.901 78.0027C596.912 78.0521 596.919 78.1054 596.919 78.1601C596.919 78.5507 596.601 78.8694 596.211 78.8694Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.187,
    y: 76.7867,
    width: 2.69336,
    height: 3.22669,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 595,
    y: 77,
    width: 2,
    height: 2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M596.088 78.8574C595.755 78.8 595.503 78.5094 595.503 78.16C595.503 77.7694 595.819 77.452 596.211 77.452C596.547 77.452 596.829 77.6867 596.901 78.0027C596.723 78.3627 596.439 78.6614 596.088 78.8574Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.52,
    y: 76.7867,
    width: 3.36003,
    height: 3.22669,
    fill: "url(#pattern3)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M498.086 316.509C497.062 316.396 495.725 316.339 494.075 316.339C492.425 316.339 491.032 317.021 489.894 318.387C488.813 319.752 488.016 322.227 487.504 325.811C487.049 329.338 487.078 331.756 487.59 333.064C488.159 334.372 489.24 335.027 490.832 335.027C491.8 335.027 492.738 334.742 493.648 334.173C494.616 333.548 495.384 332.893 495.952 332.211L498.086 316.509ZM495.952 337.416C492.71 340.317 489.552 341.768 486.48 341.768C482.043 341.768 479.512 339.009 478.886 333.491C478.658 331.556 478.744 329.167 479.142 326.323C479.54 323.421 480.223 320.947 481.19 318.899C482.157 316.851 483.295 315.172 484.603 313.864C487.049 311.475 490.093 310.28 493.734 310.28C498.057 310.28 502.409 310.707 506.79 311.56L502.608 341H495.952V337.416ZM523.699 327.688H509.107L510.046 321.373H524.467L523.699 327.688ZM547.564 325.811H537.58L535.447 341H527.169L532.631 302.259H552.855L551.916 308.915H539.969L538.433 319.496H548.417L547.564 325.811ZM563.418 341H555.482L561.37 298.675L569.477 297.565L563.418 341ZM574.178 347.912C576.738 348.765 579.212 349.192 581.602 349.192C583.308 349.192 584.418 348.964 584.93 348.509C586.011 347.542 586.75 345.921 587.148 343.645L588.172 337.16H588.002C584.987 340.175 582.028 341.683 579.127 341.683C576.226 341.683 574.32 340.829 573.41 339.123C572.5 337.359 572.272 334.685 572.727 331.101L575.628 310.792H583.65L581.004 329.139C580.777 331.528 580.748 332.979 580.919 333.491C581.317 334.344 582.114 334.771 583.308 334.771C584.674 334.771 586.238 333.946 588.002 332.296C588.4 331.955 588.713 331.699 588.94 331.528L591.842 310.792H599.778L595.17 343.475C594.601 347.457 593.292 350.387 591.244 352.264C589.196 354.198 586.181 355.165 582.199 355.165C579.412 355.165 576.226 354.568 572.642 353.373L574.178 347.912ZM612.222 296.712C613.53 296.712 614.526 297.167 615.209 298.077C615.948 298.988 616.204 300.154 615.977 301.576C615.806 302.941 615.237 304.079 614.27 304.989C613.303 305.843 612.165 306.269 610.857 306.269C609.605 306.269 608.609 305.843 607.87 304.989C607.13 304.079 606.846 302.941 607.017 301.576C607.301 300.154 607.927 298.988 608.894 298.077C609.861 297.167 610.97 296.712 612.222 296.712ZM609.918 341H601.982L606.078 311.304L614.27 310.195L609.918 341ZM622.749 310.792H629.746L629.405 314.632H629.575C629.86 314.461 630.258 314.12 630.77 313.608C631.339 313.096 632.05 312.584 632.903 312.072C635.008 310.764 637.085 310.109 639.133 310.109C641.977 310.109 643.854 310.963 644.765 312.669C645.675 314.376 645.874 317.021 645.362 320.605L642.461 341H634.695L637.17 322.568C637.454 320.406 637.426 318.956 637.085 318.216C636.743 317.42 635.975 317.021 634.781 317.021C633.757 317.021 632.818 317.334 631.965 317.96C630.372 319.212 629.49 320.008 629.319 320.349L626.418 341H618.482L622.749 310.792ZM657.113 333.149C657.34 333.832 657.71 334.316 658.222 334.6C658.734 334.828 659.445 334.941 660.355 334.941C661.265 334.941 662.204 334.6 663.171 333.917C664.138 333.235 664.906 332.552 665.475 331.869L667.097 319.837C666.186 318.7 665.418 317.932 664.793 317.533C664.167 317.135 663.427 316.936 662.574 316.936C660.697 316.936 659.36 317.732 658.563 319.325C657.824 320.861 657.283 323.165 656.942 326.237C656.43 329.196 656.487 331.5 657.113 333.149ZM650.798 347.912C653.358 348.765 655.833 349.192 658.222 349.192C659.815 349.192 660.924 348.964 661.55 348.509C662.801 347.485 663.541 345.864 663.769 343.645L664.707 337.672H664.622C663.712 338.582 662.489 339.492 660.953 340.403C659.473 341.313 657.937 341.768 656.345 341.768C654.809 341.768 653.472 341.484 652.334 340.915C651.253 340.289 650.371 339.35 649.689 338.099C648.209 335.425 647.84 331.727 648.579 327.005C649.319 321.658 650.94 317.505 653.443 314.547C655.776 311.759 658.421 310.365 661.379 310.365C663.086 310.365 664.451 310.792 665.475 311.645C666.556 312.442 667.552 313.523 668.462 314.888L669.571 310.792H676.227L671.705 343.475C671.136 347.457 669.827 350.387 667.779 352.264C665.731 354.198 662.745 355.165 658.819 355.165C656.657 355.165 654.723 354.938 653.017 354.483C651.367 354.028 650.087 353.658 649.177 353.373L650.798 347.912Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_405",
    x: 704,
    y: 38,
    width: 447,
    height: 424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_405",
    x: 0,
    y: 38,
    width: 447,
    height: 424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_405",
    transform: "scale(0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_405",
    transform: "scale(0.111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1_405",
    transform: "scale(0.25 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_1_405",
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_405",
    x1: 920.5,
    y1: 448,
    x2: 920.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C1C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_405",
    x1: 230.5,
    y1: 448,
    x2: 230.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C1C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_405",
    x1: 545.5,
    y1: 72,
    x2: 470,
    y2: 765.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_405",
    x1: 606.5,
    y1: 590.138,
    x2: 680.92,
    y2: -98.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_405",
    x1: 716.961,
    y1: 192.491,
    x2: 716.961,
    y2: 261.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552,
    stopColor: "#2B1D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105304,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904875,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939094,
    stopColor: "#2B1D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98292,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_405",
    x1: 718.187,
    y1: 192.509,
    x2: 718.187,
    y2: 261.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186012,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806376,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919115,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_405",
    x1: 435.477,
    y1: 177.959,
    x2: 435.477,
    y2: 221.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105304,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904875,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939094,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98292,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_405",
    x1: 434.777,
    y1: 177.971,
    x2: 434.777,
    y2: 221.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186012,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806376,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919115,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_405",
    x1: 436.444,
    y1: 221.705,
    x2: 436.444,
    y2: 177.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518367,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_405",
    x1: 435.477,
    y1: 232.98,
    x2: 435.477,
    y2: 276.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105304,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904875,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939094,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98292,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_405",
    x1: 434.777,
    y1: 232.992,
    x2: 434.777,
    y2: 276.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186012,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806376,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919115,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_405",
    x1: 436.444,
    y1: 276.727,
    x2: 436.444,
    y2: 232.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518367,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_405",
    x1: 435.477,
    y1: 136.639,
    x2: 435.477,
    y2: 159.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105304,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904875,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939094,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98292,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_405",
    x1: 434.777,
    y1: 136.649,
    x2: 434.777,
    y2: 159.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186012,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806376,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919115,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_405",
    x1: 436.444,
    y1: 159.099,
    x2: 436.444,
    y2: 136.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518367,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96458,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_405",
    x1: 595.121,
    y1: 80.8467,
    x2: 595.121,
    y2: 73.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_405",
    x1: 595.121,
    y1: 74.9974,
    x2: 595.121,
    y2: 79.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B131C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_405",
    width: 15,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAUBJREFUKJGFks1S3TAMhT/JshPndl8ehIH3X8LQ9m1uAP+IhXMbAs1U2nhkHR0dSfLz7s45sTRNRItYtEP8slz48/sXegb8n90/PGJnnxoCACKCqo4O7Jh+Cr6ZM1SJCuEL+LTtoIFoEdm81kop70dms/iNxbtz87C1b2aEYOAOIiOmYSd3902vYmbkJRMtEmMkpUQpdVBseSZbFWBLKExpIsaIiCIiXC4/iDHy+rrSWuO9lAFeluUvuJRCnjPIkJBzZkoJVSGEwDxn1vW6a/7K/Pk9pYSZMc8ZC4E3d1R3mWZhH7/70KOq4OCAqtJ756011nXluq47eJrnw/i9d2qt4yB8FCy1YMEIQdGt0+7+/UhEFdUxqNYq12uh9T628EkinFzY7ZJqa4d4v61ShJfnJwTw+4fHf9U4tZfnJwA+AH+jc5A39zmDAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_405",
    width: 9,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABHNCSVQICAgIfAhkiAAAAMRJREFUGJWF0LFKA1EQheH/3GxW4qIkogSCjUGstLDQKnUqKx9CH0vs8kYhxNJCElJkCSy6985YhDUoQqb+ivmP2lnm/HOWF6SDI5Rqwj4g+4sUiJcPpPELGoyQ1SjF36i+fcavn2D9hp9c4Wc3yCJZA+LgHoaPaPqKVlP88BRvd8DSFlle4P07WM+hWsJXCXIgIjfCz5OzCVQLyAu808Ptk1C+A47onXtTIbWw7gXEDWHzQajKbY+O+95UyCJYQm7Abr5vonZV760IjhkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1_405",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAEVJREFUCJljlFHV+M+ABFjY2FkYUAXYWBg8XFwZPnz8yHDi9CkGRj1Lk/+srKwMf//+Zfj37x9EBQPDfwYWFiYGBgYmBgAtwhBN2erPwAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_1_405",
    width: 5,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAAGJJREFUCJk1wbEKglAAheH/yE0rp8A18A1samxpa+4BfNMew7EHEBPkgiBeT5PfJzWtNXT4XGES4fshMPewTCADK/JGRl7i04X368HzVgNGut7NGjkuPxxHUkooHArLG2B2f3kOIpEJnXBlAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9841ea3b635dbad94e4cd375f7d2c1dc.svg";
export { ForwardRef as ReactComponent };